import React from "react";
import { connect } from "react-redux";
import { Input, Select } from "../Input/index.js";
import language from "../../language/index.js";
import { Button } from "../Button/index.js";
import api from "../../utils/api/index.js";
import toastMessage from "../../utils/toastMessage.js";
import { fetchRejectionStatus } from "../../utils/queries/rejectionStatus.js";
import bloodDonationQuery from "../../utils/queries/bloodDonationQuery.js";
import { fetchInventories } from "../../utils/queries/production/inventoryQuery.js";

let types = [
  {
    label: "Bulk",
    value: "bulk",
  },
  {
    label: "Product",
    value: "product",
  },
];

class ReceptionOfReturn extends React.Component {
  productInputRef = React.createRef();
  donationInputRef = React.createRef();

  state = {
    error: {},
    isDoneSearching: false,
    donationNumber: "",
    returnNumber: "",
    product: "",
    data: [],
    type: types[0],
    actions: [],
  
    receptionAction: null,
};

  componentDidMount() {}

  validateForm() {
    let {
      error,
      returnNumber,
      type,
      receptionAction,
      product,
      donationNumber,
    } = this.state;

    if (type?.value === "bulk" && returnNumber === "") {
      error.returnNumber =
        language[this.props.defaultLanguage].return_number_required;
    }

    if (type?.value === "product" && donationNumber === "") {
      error.donationNumber =
        language[this.props.defaultLanguage].donation_number_required;
    }

    if (type?.value === "product" && product === "") {
      error.product = language[this.props.defaultLanguage].product_required;
    }

    if (!receptionAction) {
      error.receptionAction =
        language[this.props.defaultLanguage].action_required;
    }

    this.setState({ error });
  }

  onSubmit = async () => {
    await this.validateForm();

    try {
      if (Object.keys(this.state.error).length > 0) return;

      const { returnNumber, type, receptionAction, product, donationNumber } =
        this.state;

      this.setState({
        isSubmitting: true,
      });

      let method = "POST",
        requestBody = {
          returnNumber,
          receptionAction: receptionAction._id,
          type: type.value,
          product,
          donationNumber,
        };

      const options = {
        method,
        url: `${process.env.REACT_APP_BBMS_BASE_API}/reception`,
        data: requestBody,
      };

      await api(options);

      this.setState({
        isSubmitting: false,
        returnNumber: "",
        product: "",
        donationNumber: "",
      });

      toastMessage(
        "success",
        language[this.props.defaultLanguage].add_data_success
      );
    } catch (error) {
      console.log(error);
      this.setState({ isSubmitting: false });
      toastMessage("error", error);
    }
  };

  autoFillProduct = async (donationNumber) => {
    try {
      const donations = await bloodDonationQuery(this.props.defaultLanguage, { donationNumber });
      const donationId = donations?.[0]?._id;
      if (!donationId) {
        this.productInputRef.current?.focus();
        return;
      }

      const { data } = await fetchInventories(this.props.defaultLanguage, {
        donation: donationId,
        limit: 10,
        noStockFilter: true,
      });

      if (data?.length === 1) {
        this.setState({ product: data[0].code }, () => {
          this.productInputRef.current?.focus();
        });
      } else {
        this.productInputRef.current?.focus();
      }
    } catch (_) {
      this.productInputRef.current?.focus();
    }
  };

  onChangeText = async (field, e) => {
    let { error } = this.state;
    let inputValue = e && e?.target ? e?.target?.value : e;

    delete error[field];

    if (field === "type") {
      delete error.type;
    }

    this.setState({
      [field]: inputValue,
      isDoneSearching: false,
      ...(field === "donationNumber" ? { product: "" } : {}),
    });

    if (field === "donationNumber" && inputValue.length === 7) {
      this.productInputRef.current?.focus();
    }

    if (field === "product" && inputValue.length === 5) {
      this.donationInputRef.current?.focus();
    }
  };

  getStatuses = async () => {
    try {
      this.setState({
        isFetchingStatuses: true,
      });

      const { data } = await fetchRejectionStatus("dropdown", {
        type: ["ACTIONS"],
      });

      this.setState({
        reasons: data,
        isFetchingStatuses: false,
      });

      return data;
    } catch (error) {
      this.setState({ isFetchingStatuses: false });

      return [];
    }
  };

  render() {
    return (
      <div className="row">
        <div className="col-md-12">
          <Select
            options={types}
            placeholder={language[this.props.defaultLanguage].select}
            label={language[this.props.defaultLanguage].type}
            value={this.state.type}
            onChange={(e) => this.onChangeText("type", e)}
            error={this.state.error.type}
          />
        </div>
        {this.state.type?.value === "bulk" && (
          <div className="col-md-12">
            <Input
              placeholder={
                language[this.props.defaultLanguage].return_number_placeholder
              }
              label={language[this.props.defaultLanguage].return_number}
              value={this.state.returnNumber}
              onChange={(e) => this.onChangeText("returnNumber", e)}
              error={this.state.error.returnNumber}
              type="number"
            />
          </div>
        )}

        {this.state.type?.value === "product" && (
          <>
            <div className="col-md-12">
              <Input
                placeholder={
                  language[this.props.defaultLanguage]
                    .donation_number_placeholder
                }
                label={language[this.props.defaultLanguage].donation_number}
                value={this.state.donationNumber}
                onChange={(e) => this.onChangeText("donationNumber", e)}
                error={this.state.error.donationNumber}
                inputRef={this.donationInputRef}
                maxLength={7}
                inputMode="numeric"
              />
            </div>
            <div className="col-md-12">
              <Input
                placeholder={
                  language[this.props.defaultLanguage].product_placeholder
                }
                label={language[this.props.defaultLanguage].product}
                value={this.state.product}
                onChange={(e) => this.onChangeText("product", e)}
                error={this.state.error.product}
                inputRef={this.productInputRef}
                maxLength={5}
                inputMode="numeric"
              />
            </div>
          </>
        )}

        <div className="col-md-12">
          <Select
            loadOptions={(e) => this.getStatuses(true)}
            placeholder={language[this.props.defaultLanguage].select}
            label={language[this.props.defaultLanguage].action}
            value={this.state.receptionAction}
            onChange={(e) => this.onChangeText("receptionAction", e)}
            error={this.state.error.receptionAction}
            isLoading={this.state.isFetchingStatuses}
          />
        </div>

        <div>
          <Button
            text={language[this.props.defaultLanguage].submit}
            isSubmitting={this.state.isSubmitting}
            onPress={this.onSubmit.bind(this)}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(ReceptionOfReturn);
